import { render, staticRenderFns } from "./JoinTitleParagraph.ts.vue?vue&type=template&id=25fb07cc&"
import script from "./JoinTitleParagraph.ts.vue?vue&type=script&lang=ts&"
export * from "./JoinTitleParagraph.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports